<template>
  <div class="contentBox"  v-loading="loading" :element-loading-text="loadTxt" :class="device=='mobile'?'mobileBox':''">
    <button class="btn btn-back" @click="goBack"></button>
    <web ref="web" class="webBox"></web>
    <p class="title">习题{{dataObj.num}}</p>
    <div class="detail">
      <div class="detail-item">
        <div class="detail-txt">
          <div class="left">
            <p class="txt">{{listData.content}}</p>
          </div>
          <div class="right">
            <div class="right-item" v-for="(item,index) in listData.topics" :key="index">
              <p class="topic-title">{{(index+1)}}. {{item.topic}}</p>
              <textarea name="" id="" v-model="item.my_answer"></textarea>
              <div class="answer" v-if="item.status == 1">
                <div class="answer-title">
                  你的回答: 
                  <img v-if="topicRtid==item.rtid" src="./../../src/assets/images/answer-loading.gif" alt="" class="answer-loading">
                  <div v-else>
                    <span>{{item.is_true==0?'未知':item.is_true==1?'回答正确!':'回答错误！'}}</span>
                    <button class="btn btn-refresh" @click="newComment(item)">点击刷新</button>
                  </div>
                </div>
                <p class="answer-txt">正确答案: <span>{{item.answer}}</span></p>
              </div>
            </div>
            <button class="btn btn-sub" v-if="listData.status == 0" @click="btnSub">{{btnTxt}}</button>
            <div class="" v-if="listData.status==1">
              <div class="aiBox" v-if="listData.is_true==0">
                <p class="ai-title">{{listData.type==1?'AI错因分析':'AI点评'}}:</p>
                <div class="ai-txt" v-if="error_analysis_type">
                  <img src="./../../src/assets/images/ai-loading.gif" alt="">
                </div>
                <div class="ai-txt" v-else>{{listData.ai_error_analysis}}</div>
              </div>
              <div class="aiBox">
                <p class="ai-title">AI习题讲解:</p>
                <div class="ai-txt">{{listData.explain?listData.explain:'暂无'}}</div>
              </div>
              <button class="btn btn-sub" v-if="listData.type==1" @click="detailSub">{{listData.is_true==1?'下一题':'去复盘'}}</button>
              <button class="btn btn-sub" v-else @click="nextTopic">下一题</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getReadTopicDetail , addReadTopicAnswer ,addReadTopicComment ,refreshAiErrorTopic,refreshTopicJudge } from "@/assets/js/api";
import web from './../components/comment/web.vue';
export default {
  name: "login",
  data() {
    return {
      token:'',
      dataObj:{},
      listData:[],
      loading:false,
      loadTxt:'',
      topicRtid:'',
      error_analysis_type:false,
      device:'',
      btnTxt:'提交答案'
    };
  },
  components: {
    web
  },
  mounted(){
    document.title = '练习题'
    var userData = JSON.parse(localStorage.getItem('identityData'));
    this.token = userData.apiToken;
    this.dataObj = {
      rmid:this.$route.query.rmid,
      rpid:this.$route.query.rpid,
      num:this.$route.query.num,
    }
    this.getDetail();
    this.device = this.$refs.web.device;
    if(this.device == 'mobile'){
      this.$refs.web.font_resize();
    }
  },
  methods: {
    async getDetail(){
      var that = this;
      try {
        const response = await getReadTopicDetail({rmid:this.dataObj.rmid,rpid:this.dataObj.rpid},this.token);
        if(response.code == 200){
          that.listData = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    btnSub(){
      var that = this;
      try {
          that.listData.topics.forEach(function(item,index){
            if(item.my_answer == '' || !item.my_answer){
                that.$message('题目'+(index+1)+'答案还未填写');
                throw new Error("EndIterative");
            } 
          })
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
      this.listData.topics.forEach(function(item,index){
        setTimeout(function(){
          that.answerSub(item,index)
        },index*100)
      })
    },

    async answerSub(e,i){
      var that = this;
      var obj = {
        rpid:this.dataObj.rpid,
        rmid:this.dataObj.rmid,
        rtid:e.rtid,
        my_answer:e.my_answer
      }
      this.btnTxt = '请稍后'
      try {
        const response = await addReadTopicAnswer(obj,this.token);
        if(response.code == 200){
          that.listData.topics[i].is_true = response.data.ai_judge;
          console.log(i+1 , that.listData.topics.length)
          if(i+1 == that.listData.topics.length){
            that.getComment();
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },


    async getComment(){
      var that = this;
      var obj = {
        rpid:this.dataObj.rpid,
        rmid:this.dataObj.rmid,
      }
      this.loading = true;
      this.loadTxt = 'ai生成中...'
      try {
        const response = await addReadTopicComment(obj,this.token);
        if(response.code == 200){
          that.listData.ai_error_analysis = response.data.ai_error_analysis;
          that.listData.status = 1;
          that.btnTxt = '提交答案'
          that.getDetail();
        } else {
          that.$message(response.msg);
        };
        that.loading = false;
      } catch (error) {
        that.$message(error);
        that.loading = false;
      }
    },

    async newComment(e){
      var that = this;
      this.error_analysis_type = true;
      var obj = {
        rmid:that.dataObj.rmid,
        rpid:that.dataObj.rpid,
        rtid:e.rtid,
      }
      this.topicRtid = e.rtid;
      try {
        const response = await refreshTopicJudge(obj,this.token);
        if(response.code == 200){
          e.is_true = response.data.ai_judge;
          that.listData.ai_error_analysis = response.data.ai_error_analysis;
          that.listData.status = 1;
          that.topicRtid = '';
          that.error_analysis_type = false;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }

      // try {
      //   const response = await refreshAiErrorTopic({utid:this.listData.utid},this.token);
      //   if(response.code == 200){
      //     that.listData.ai_error_analysis = response.data.answer;
      //     that.listData.status = 1;
      //     that.loading = false;
      //   } else {
      //     that.$message(response.msg);
      //   }
      // } catch (error) {
      //   that.$message(error);
      // }
    },

    detailSub(){
      if(this.listData.is_true == 1){
        this.$router.push('/exam?rmid='+this.dataObj.rmid)
      } else {
        this.$router.push('/examReplay?rmid='+this.dataObj.rmid + '&rpid='+this.dataObj.rpid+'&num='+this.dataObj.num)
      }
    },

    nextTopic(){
      this.$router.push('/exam?rmid='+this.dataObj.rmid)
    },

    goBack() {
      var that = this;
      that.$router.go(-1);
      setTimeout(function(){
        window.location.reload();
      },100)
    }
  },

  
};
</script>
<style scoped>
  .contentBox{
    width: 100%;
    height: 100%;
    padding: 101px 0 75px;
    background-color: #F8F9FC;
  }

  .title{
    color: #333333;
    font-size: 40px;
    display: block;
    font-weight: bold;
    text-align: center;
  }

  .btn-back{
    background-image: url(~@/assets/images/btn-bg1.png);
  }

  .detail{
    height: calc( 100% - 100px );
    
  }

  .detail-item{
    margin-top: 20px;
    padding: 0 80px;
    box-sizing: border-box;
    height: 100%;
  }

  .detail-txt{
    display: block;
    margin-top: 10px;
    font-size: 0;
    height: 100%;
  }

  .detail-txt .right,
  .detail-txt .left{
    width: 50%;
    display: inline-block;
    vertical-align: top;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .detail-txt .left{
    background-color: #F7F9FA;
    border-radius: 6px;
  }

  .detail-txt .left .txt{
    color: #000000;
    font-size: 22px;
    padding: 15px;
    box-sizing: border-box;
    white-space: pre-line;
  }

  .right-item{
    margin-bottom: 50px;
    display: block;
  }

  .right-item .topic-title{
    color: #333333;
    font-size: 24px;
    white-space: pre-line;
  }

  .right-item textarea{
    width: 100%;
    height: 300px;
    border-radius: 6px;
    border: solid 1px #333;
    margin-top: 10px;
    box-sizing: border-box;
    padding: 20px;
    font-size: 18px;
  }

  .btn-sub{
    font-size: 32px;
    color: #fff;
    padding: 15px 61px;
    border-radius: 60px;
    background-color: #6098F2;
    display: block;
    margin: 20px auto 0;
  }

  .answer{
    font-size: 0;
  }

  .answer .answer-title,
  .answer p{
    font-size: 24px;
    color: #333333;
    margin-top: 20px;
  }

  .answer .answer-title span{
    color: #E2231A;
  }

  .answer .answer-txt span{
    font-size: 18px;
  }

  .answer .answer-title img,
  .answer .answer-title div{
    display: inline-block;
    vertical-align: top;
  }

  .aiBox{
    display: block;
    margin-bottom: 20px;
  }

  .ai-title{
    font-size: 24px;
    color: #333333;
  }

  .ai-title::before{
    content: '';
    width: 8px;
    height: 40px;
    background-color: #6098F2;
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }

  .ai-txt{
    font-size: 18px;
    color: #333;
    background-color: #EDEDED;
    border-radius: 6px;
    padding: 20px;
    box-sizing: border-box;
    margin-top: 20px;
    white-space: pre-line;
  }

  .btn-refresh{
    display: inline-block;
    vertical-align: top;
    padding: 5px 20px;
    border-radius: 6px;
    margin-left: 20px;
    background-color: #6098F2;
    color: #fff;
    font-size: 16px;
  }

  .answer-loading{
    width: 212px;
    height: 46px;
    display: block;
  }

  .mobileBox .detail{
    height: calc( 100% - .5rem );
  }

  .mobileBox .btn-back{
    height: .52rem;
    width: .52rem;
    background-size: .52rem .52rem;
  }

  .mobileBox .title{
    font-size: .3rem;
  }

  .mobileBox .detail-txt .left .txt{
    font-size: .18rem;
    padding: .2rem;
  }

  .mobileBox .right-item .topic-title{
    font-size: .2rem;
  }

  .mobileBox .btn-sub{
    font-size: .24rem;
  }

  @media screen and (max-width: 1600px){
    .contentBox{
      padding: 20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/identity/examTopic.vue